import { useLocalStorageEvent } from 'hooks/useLocalStorageEvent';
import { LocalStorageService } from 'services/localStorage/localStorage';
import { DashboardRoutes } from 'support/types';
import { PartnerKeys } from 'support/types/localStorage';

const setPartner = (partnerId: string): void => {
  LocalStorageService.setItem(PartnerKeys.activePartnerId, partnerId);
};

/**
 * Detects when a partner switch has occurred in another browser tab and
 * performs a full page reload to the dashboard under the new partner context.
 *
 * When `useSwitchPartner` succeeds it calls `MultiPartnerService.setPartner`,
 * which writes to localStorage. The browser fires a `storage` event in every
 * OTHER open tab, letting them react without polling.
 *
 * A full reload is used instead of a client-side navigation so that ALL
 * in-memory state (query cache, Zustand stores, WebEDI state, etc.) is
 * guaranteed to be wiped clean for the new partner context.
 */
const usePartnerSwitchSync = (currentPartnerId: string | undefined): void => {
  useLocalStorageEvent(PartnerKeys.activePartnerId, (newPartnerId) => {
    if (!newPartnerId || newPartnerId === currentPartnerId) {
      return;
    }
    // Full page reload — clears all in-memory state for the new partner.
    window.location.href = DashboardRoutes.root;
  });
};

export const MultiPartnerService = {
  setPartner,
  usePartnerSwitchSync,
};
